import {Injectable, Inject} from 'ng-metadata/core';
import {SearchFieldsService} from "../../search/search.fields.service";
import {ChangeLangService} from '../../infra/lang/changeLang.service';

@Injectable()
export class PagesTitlesService{

    private PagesTitlesService:any;

    constructor(private searchFieldsService: SearchFieldsService,
                private changeLangService: ChangeLangService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService){

    }

    public setTitle(title: string ){
        let titleElement = <HTMLLinkElement>document.getElementById('primoExploreTitle');
        let titleOgElement = <HTMLMetaElement>document.getElementById('ogTitle');
        title = title.replace(/\s*\-\s*$/, "");
        title = title.replace(/<[^>]*>/g, '');
        titleElement.innerHTML = title;
        titleOgElement.content = title;
    }

    public async updatePagesTitles(titles?) {
        if (titles && titles.codes){
            let titlesTranslated = await this.$translate(titles.codes, {query: titles.placeHolder})
            if (titlesTranslated.$$QUERY$$) {
                titlesTranslated.$$QUERY$$ = titles.query;
            }
            let titlesTranslatedValues = Object.values(titlesTranslated);
            titlesTranslatedValues = titlesTranslatedValues.filter(s => !!s);
            if (this.changeLangService.direction === 'rtl'){
                titlesTranslatedValues.reverse();
            }
            let titlesMerged = titlesTranslatedValues.join(' - ');
            this.setTitle((titlesMerged))
        }
    }



}



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/accessibility/pagesTitles.service.ts